
import cmBlank from '@/components/cmBlank';
import Selector from 'vux/src/components/selector/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'


export default {
components: {
cmBlank,Selector,Group,PopupRadio
},
data(){
return {
blankShow:false,
cid:0,
amount:0,
number:0,
cate_id:0,
cateName:'分类',
title:'',
cate:[],
list:[],
where:[],
}
},
mounted(){
this.cid = parseInt(this.$route.params.cid);
this.category();
this.getList();
},
methods: {
reset(){
this.title = '';
this.list = [];
this.getList();
},
search(){
this.list = [];
this.getList();
},
category(){
this.$api.pickCategory({}).then((res)=>{
if(res){
this.cate = res.data;
}
})
},
getList(){
this.$api.purchase({cid:this.cid,title:this.title,cate_id:this.cate_id}).then((res)=>{
if(res){
this.list = res.data;
this.blankShow = res.data.length > 0 ? false : true;
}
})
},
sub(i){
let that = this;
this.list[i].num = Number(this.list[i].num);
if(this.list[i].num > 0){
this.list[i].num = this.list[i].num - 1;
}else{
this.list[i].num = 0;
}
that.countPrice();
},
add(i){
this.list[i].num = parseInt(this.list[i].num) + 1;
this.countPrice();
},
input(){

this.countPrice();
},
countPrice(){
let that = this;
that.amount = 0;
that.number = 0;
that.list.forEach((item,index)=>{
that.amount = (Number(that.amount) + Number(item.pick_price) * parseInt(item.num)).toFixed(2);
that.number = Number(that.number) + Number(item.num);
})
},
confirmOrder() {
let that = this;
this.param = [];
that.list.forEach((item) => {
this.param.push({id:item.id,num:item.num});
});
if(!this.param.length){
this.$func.showToast('请选择商品');
return false;
}
if(this.number <= 0){
this.$func.showToast('请选择商品');
return false;
}
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
}else{
this.onBridgeReady();
}
},
onBridgeReady(){
let that = this;
this.$api.pickGoodsOrder({param:JSON.stringify(this.param)}).then((res)=>{
if(res){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
setTimeout(()=>{
that.reset();
},300);
}else{
that.$func.showToast('已取消支付');
}
}
);
}
})
},
},
}



// WEBPACK FOOTER //
// ./src/pages/pickGoods.vue